export default __webpack_public_path__ + "static/Brixton_Wood-Vector-42c89ebe7489f49789e661bd86ad1f29.woff2";